import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { ErrorFeatureToggle } from '@alfa-bank/newclick-composite-components/error-feature-toggle';
import { SidePanel } from '@alfa-bank/newclick-composite-components/side-panel';
import cn from 'classnames';
import { Button } from '@alfalab/core-components/button';
import { useWebview } from '../../hooks/use-webview';
import { useWidgetContext } from '../../hooks/use-widget-context';
import styles from './index.module.css';
export const FeatureToggle = () => {
    const { isWebview } = useWidgetContext();
    const { bridgeToNative } = useWebview();
    const closeWebview = () => {
        bridgeToNative?.closeWebview();
    };
    return (_jsxs(React.Fragment, { children: [_jsx(SidePanel.Body, { className: cn({ [styles.body]: isWebview }), children: _jsx(ErrorFeatureToggle, { dataTestId: 'error-feature-toggle', showButton: !isWebview }) }), isWebview && (_jsx(SidePanel.Actions, { className: styles.actions, children: _jsx(Button, { block: true, onClick: closeWebview, children: "\u041F\u043E\u043D\u044F\u0442\u043D\u043E" }) }))] }));
};
